module.exports = __webpack_public_path__ + "static/media/34_tn.e05be716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/34_tn.jpg
// module id = 247
// module chunks = 0